
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"-2 -2 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M9.7804 8.71974c.2928.29278.2928.76788 0 1.06066-.29278.2928-.76788.2928-1.06066 0L4.99999 6.06065 1.28024 9.7804c-.292779.2928-.767873.2928-1.060654 0-.2927813-.29278-.2927813-.76788 0-1.06066L3.93934 4.99999.219586 1.28024c-.2927813-.292779-.2927813-.767873 0-1.060654.292781-.2927813.767875-.2927813 1.060654 0L4.99999 3.93934 8.71974.219586c.29278-.2927813.76788-.2927813 1.06066 0 .2928.292781.2928.767875 0 1.060654L6.06065 4.99999 9.7804 8.71974z"}})])
          )
        }
      }
    